var map = {
	"./ahmandulCaptain.png": 4944,
	"./ahmandulCaptainBodyguard.png": 4933,
	"./ahmandulGeneral.png": 1500,
	"./ahmandulGeneralBodyguard.png": 3665,
	"./ahmandulLieutenant.png": 1105,
	"./akshara.png": 8381,
	"./amnon.png": 8899,
	"./archer.png": 9455,
	"./arnold.png": 8058,
	"./arquebusJanissary.png": 1446,
	"./arquebusRajput.png": 382,
	"./arquebusier.png": 1338,
	"./ashigaru.png": 8032,
	"./ashish.png": 3454,
	"./axeBarbarian.png": 1496,
	"./axeThrower.png": 6135,
	"./barbarian.png": 1054,
	"./barbarianHorseman.png": 2351,
	"./bard.png": 2627,
	"./batu.png": 3400,
	"./berserker.png": 6587,
	"./bogdan.png": 9927,
	"./bowBarbarian.png": 2492,
	"./bowDruzhina.png": 5761,
	"./bowman.png": 6370,
	"./boyar.png": 9779,
	"./camelWarrior.png": 4022,
	"./cataphract.png": 2185,
	"./champion.png": 8707,
	"./crossbowMilitia.png": 759,
	"./crossbowman.png": 3936,
	"./desertCavalry.png": 3735,
	"./desertHorseArcher.png": 8923,
	"./desertSpearman.png": 8432,
	"./desertWarrior.png": 4719,
	"./druzhina.png": 5535,
	"./druzhinaWarrior.png": 5385,
	"./dulna.png": 8724,
	"./egon.png": 5413,
	"./einar.png": 1877,
	"./elaine.png": 4212,
	"./elephantArcher.png": 7664,
	"./elephantArquebusier.png": 111,
	"./gasher.png": 5922,
	"./gendarme.png": 7807,
	"./greataxeman.png": 3491,
	"./greatswordHighlander.png": 9198,
	"./greatswordsman.png": 6477,
	"./guard.png": 8019,
	"./halberdBoyar.png": 2019,
	"./halberdier.png": 6968,
	"./hammerer.png": 7965,
	"./handCannoneer.png": 4972,
	"./harald.png": 4172,
	"./haru.png": 8480,
	"./hashashin.png": 7097,
	"./heavyBowman.png": 4641,
	"./heavyHorseman.png": 9460,
	"./heavyLongbowArcher.png": 9314,
	"./heavyPikeman.png": 9306,
	"./heavySpearman.png": 1804,
	"./heavySwordsman.png": 7111,
	"./horseman.png": 5851,
	"./huscarle.png": 1601,
	"./imhotep.png": 8196,
	"./impaler.png": 5872,
	"./isidur.png": 6636,
	"./janissary.png": 9436,
	"./kassarCaptain.png": 89,
	"./kassarCaptainBodyguard.png": 5586,
	"./kassarGeneral.png": 1593,
	"./kassarGeneralBodyguard.png": 4754,
	"./kassarLieutenant.png": 8310,
	"./katanaAshigaru.png": 6310,
	"./katanaCavalry.png": 1012,
	"./katanaRonin.png": 734,
	"./katanaSamurai.png": 6292,
	"./khansGuard.png": 4704,
	"./kioshi.png": 7421,
	"./knight.png": 2657,
	"./loargenCaptain.png": 2730,
	"./loargenCaptainBodyguard.png": 9819,
	"./loargenGeneral.png": 1906,
	"./loargenGeneralBodyguard.png": 9987,
	"./loargenLieutenant.png": 3831,
	"./longbowArcher.png": 9799,
	"./longspearman.png": 5837,
	"./longswordsman.png": 4120,
	"./magyar.png": 9857,
	"./mamluk.png": 6535,
	"./mamlukArcher.png": 2026,
	"./mamlukWarrior.png": 7489,
	"./manAtArms.png": 2554,
	"./mangudai.png": 1184,
	"./menar.png": 5961,
	"./miklos.png": 955,
	"./montaneArcher.png": 201,
	"./mountedBoyar.png": 365,
	"./mountedCrossbowman.png": 4434,
	"./mountedDruzhina.png": 741,
	"./mountedKnight.png": 4287,
	"./mountedMamluk.png": 7797,
	"./mountedNomad.png": 5803,
	"./mountedRanger.png": 1155,
	"./naginataSamurai.png": 3445,
	"./natureCaptain.png": 7791,
	"./natureCaptainBodyguard.png": 6700,
	"./natureGeneral.png": 2699,
	"./natureGeneralBodyguard.png": 4136,
	"./natureLieutenant.png": 9792,
	"./nomad.png": 3773,
	"./nomadArcher.png": 3012,
	"./nomadSpearman.png": 8288,
	"./nomadWarrior.png": 2207,
	"./nordicArcher.png": 556,
	"./nordicAxeman.png": 5113,
	"./nordicCavalry.png": 671,
	"./nordicSpearman.png": 7576,
	"./nordicWarrior.png": 2343,
	"./odinsSpear.png": 9932,
	"./otto.png": 904,
	"./paladin.png": 5349,
	"./peasant.png": 5956,
	"./pikeHighlander.png": 1137,
	"./pikeman.png": 9355,
	"./poleaxeman.png": 9820,
	"./radovan.png": 3999,
	"./raider.png": 4459,
	"./rajput.png": 5324,
	"./ranger.png": 977,
	"./ronan.png": 5032,
	"./sailo.png": 8042,
	"./samama.png": 3414,
	"./skirmisher.png": 1603,
	"./skullCrusher.png": 3336,
	"./sohei.png": 1996,
	"./soldier.png": 7682,
	"./spearBarbarian.png": 5045,
	"./spearDruzhina.png": 8702,
	"./spearman.png": 9783,
	"./steppeArcher.png": 460,
	"./steppeCavalry.png": 7327,
	"./steppeHorseArcher.png": 1187,
	"./steppeWarrior.png": 7015,
	"./swanCavalry.png": 163,
	"./swordBarbarian.png": 5229,
	"./swordsman.png": 802,
	"./therestaniaCaptain.png": 7314,
	"./therestaniaCaptainBodyguard.png": 4611,
	"./therestaniaGeneral.png": 4170,
	"./therestaniaGeneralBodyguard.png": 2587,
	"./therestaniaLieutenant.png": 6719,
	"./tsagenkhanCaptain.png": 6330,
	"./tsagenkhanCaptainBodyguard.png": 4955,
	"./tsagenkhanGeneral.png": 5506,
	"./tsagenkhanGeneralBodyguard.png": 5123,
	"./tsagenkhanLieutenant.png": 9495,
	"./tuareg.png": 9382,
	"./ulfsark.png": 7994,
	"./ultamar.png": 7446,
	"./unknown.png": 9026,
	"./warElephant.png": 9221,
	"./wingedHussar.png": 5929,
	"./wolveskreitCaptain.png": 4403,
	"./wolveskreitCaptainBodyguard.png": 6208,
	"./wolveskreitGeneral.png": 983,
	"./wolveskreitGeneralBodyguard.png": 1764,
	"./wolveskreitLieutenant.png": 7340,
	"./yariAshigaru.png": 9605,
	"./yariCavalry.png": 489,
	"./yariRonin.png": 6243,
	"./yariSamurai.png": 105,
	"./yasin.png": 2868,
	"./yokitikoyCaptain.png": 5890,
	"./yokitikoyCaptainBodyguard.png": 7363,
	"./yokitikoyGeneral.png": 1930,
	"./yokitikoyGeneralBodyguard.png": 1355,
	"./yokitikoyLieutenant.png": 2607,
	"./yoshiko.png": 412,
	"./yumiAshigaru.png": 788,
	"./yumiRonin.png": 964,
	"./yumiSamurai.png": 6645,
	"./yumiSohei.png": 9800
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9553;